export default {
  title: 'Gem kontakt- og betalingsoplysninger',
  form: {
    remember_me: {
      label: 'Opret en konto for hurtigere checkout ved fremtidige ordrer.',
    },
  },
};
